<template>
    <div class="bg">
        <img class="mobileTerminalBG" src="../assets/mobileTerminalBG.png" alt="">
        <div class="title">
            <span>第三方授权平台</span>
        </div>
        <div class="inputBG">
            <input v-model="orgCode" class="input" type="text" placeholder="请输入机构编码">
            <div @click="addCode" class="btn">
                提 交
            </div>
        </div>

    </div>
</template>

<script>
    import { Toast } from 'vant';
    export default {
        name: "mobileTerminal",
        data(){
            return {
                code:'',
                orgCode:'',
            }
        },
        mounted() {
            this.saveQrCodeAndCourse()
        },
        methods:{
            async saveQrCodeAndCourse(){
                var res = await this.$api.home.getWxPreAuthCode({});
                console.log(res.data);
                this.code = res.data.pre_auth_code
            },
            addCode(){
                var code  = this.code;
                if(!this.orgCode){
                    Toast.fail('请输入机构编码~');
                    return
                }
                var url = 'https://' + location.host;
                if(location.host.indexOf('localhost') != -1){
                    url = 'https://eistest.unishining.com'
                }
                var appid = 'wx470f0482e5681910';
                if(location.host == 'zxop.unishining.com'){
                    appid = 'wx734ec7e1eea7ba29';
                }
                window.location = "https://mp.weixin.qq.com/cgi-bin/componentloginpage?component_appid="+appid+"&pre_auth_code=" +  code +  "&redirect_uri=" + url +"/wechat/wechatToken/oauthCallBack?orgCode=" + this.orgCode
            }
        },

    }
</script>
<style scoped>
.mobileTerminalBG{
    width: 100%;
    margin-bottom: 20px;
}
.title{
    margin: 0 auto 50px auto;
    text-align: center;
    font-size: 20px;
    color: #333333;
}
.inputBG{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.input{
    width: 323px;
    height: 50px;
    border-radius: 25px;
    border: 1px solid #D9D9D9;
    color: #333;
    padding: 0 20px;
    text-align: center;
    box-sizing: border-box;
    margin-bottom: 30px;
}
.input::-webkit-input-placeholder{
    color: #a7a7a7;
}
.btn{
    width: 323px;
    height: 50px;
    border-radius: 25px;
    background: #3CBFF9;
    box-shadow: 0 10px 30px 0px rgba(60,191,249,.3);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #FFFFFF;
    position: relative;
}
</style>